import { DemandResourceGrid } from "@/components/demands/DemandResourceGrid";
import { Eyebrow } from "@/components/shared/Eyebrow";
import type { PlanNosDemandLinkView } from "@/schemas/resource-plans";

/**
 * Resource Plan ▸ Actuals ▸ NOS Demand — the linked Demand as NOS has it: each person's
 * guidance and actual hours by month, the same grid the Demands page opens. Read-only;
 * changing the guidance is the plan's own grid plus Post to NOS.
 */
export function PlanNosDemandSection({ demand }: { demand: PlanNosDemandLinkView }) {
  return (
    <section className="flex flex-col gap-2">
      <div>
        <Eyebrow>NOS Demand</Eyebrow>
        <h2 className="font-display text-lg font-semibold text-heading">
          {demand.demandName ?? "Untitled Demand"}
        </h2>
      </div>
      <div className="rounded-md border border-border bg-card">
        <DemandResourceGrid demandId={demand.demandId} />
      </div>
    </section>
  );
}
